import {
  GENERAL_CHANGE_VALUES,
} from '@shared/store/constants/mutationTypes';

import apiClient from '@shared/lib/general/apiClient';

const actions = {
  changeGeneralValues({ commit }, payload) {
    commit({
      type: GENERAL_CHANGE_VALUES,
      changes: payload,
    });
  },
  async getStatesData({ dispatch }) {
    const { data: states } = await apiClient({
      method: 'GET',
      url: '/states/all',
    });
    dispatch('changeGeneralValues', [{
      field: 'states',
      value: states,
    }]);
  },
  async getCountriesData({ dispatch }) {
    const { data: countries } = await apiClient({
      method: 'GET',
      url: '/countries/all',
    });
    dispatch('changeGeneralValues', [{
      field: 'countries',
      value: countries,
    }]);
  },
  async getProductsData({ dispatch }) {
    const { data } = await apiClient({
      method: 'GET',
      url: '/products/all?platform=noc',
    });
    dispatch('changeGeneralValues', [{
      field: 'products',
      value: data,
    }]);
  },
  async getAllProductsData({ dispatch }) {
    const { data } = await apiClient({
      method: 'GET',
      url: '/products/all',
    });
    dispatch('changeGeneralValues', [{
      field: 'allProducts',
      value: data,
    }]);
  },
};

export default actions;
